<template>
  <div>
    <v-container fluid class="pa-0 vacancyOveriew">
      <IntroText
                  :intro-one="pageItem.ShortText"
                  :pageItem="pageItem"
                  :showForm =false
            />
      <v-container fluid class="vacancyOveriewContainer">
        <v-container>
          <VacancyFilters />
          <VacancyResults :vacancy-data="vacancyData" />
        </v-container>
      </v-container>
      <IntroText
                :intro-one="pageItem.MainText"
                :pageItem="pageItem"
                :showForm =false
              />
    </v-container>
  </div>
</template>

<style scoped>
.spinner-force {
  animation: v-progress-circular-rotate 1.4s linear infinite !important;
}

@keyframes v-progress-circular-rotate {
  to {
    transform: rotate(360deg);
  }
}
:deep(.loading-content-force) {
  opacity: 1 !important;
  z-index: 1 !important;
} 
</style>

<script setup>
import { vacancyRepository } from '@/layers/vacancies/repositories/vacancyRepository'
import IntroText from "@/components/Base/introText.vue";

const { t } = useI18n();

const props = defineProps({
  pageItem: {
    type: Object,
    default: () => ({})
  }
})

const route = useRoute()
const vacancyData = ref({ total: 0, vacancies: [] })
const loading = ref(false)

const loadVacancies = async () => {
  loading.value = true
  try {
    const result = await vacancyRepository.search(route.query)
    vacancyData.value = result
  } catch (error) {
    console.error('Failed to load vacancies:', error)
  } finally {
    loading.value = false
  }
}

if (import.meta.server) {
  const result = await vacancyRepository.search(route.query)
  vacancyData.value = result
}

if (import.meta.client) {
  onMounted(() => {
    loadVacancies()
  })
}

// Watch for route query changes
watch(() => route.query, (newQuery, oldQuery) => {
  loadVacancies()
}, { deep: true })
</script>
